import React, { useState, useEffect } from 'react';
import { QrCode, Download, Coffee, Share2, Wifi, Type, Link as LinkIcon, Lock, Sparkles, Zap, ShieldCheck } from 'lucide-react';

export default function App() {
  const [text, setText] = useState('https://twoja-strona.pl');
  const [size, setSize] = useState(300);
  const [color, setColor] = useState('000000');
  const [bgColor, setBgColor] = useState('ffffff');
  const [type, setType] = useState('url'); // url, wifi, text
  
  // WiFi specific states
  const [ssid, setSsid] = useState('');
  const [password, setPassword] = useState('');
  const [encryption, setEncryption] = useState('WPA');

  const [qrUrl, setQrUrl] = useState('');

  // Generowanie URL do API QR Server
  useEffect(() => {
    let dataToEncode = text;

    if (type === 'wifi') {
      dataToEncode = `WIFI:T:${encryption};S:${ssid};P:${password};;`;
    }

    const encodedText = encodeURIComponent(dataToEncode);
    const url = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodedText}&color=${color.replace('#', '')}&bgcolor=${bgColor.replace('#', '')}&margin=10`;
    setQrUrl(url);
  }, [text, size, color, bgColor, type, ssid, password, encryption]);

  const handleDownload = async () => {
    try {
      const response = await fetch(qrUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `qr-code-${Date.now()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      alert("Aby pobrać: Kliknij prawym przyciskiem myszy na obrazek i wybierz 'Zapisz grafikę jako'.");
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-800 flex flex-col justify-between">
      
      {/* HEADER */}
      <nav className="bg-white/80 backdrop-blur-md border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="bg-gradient-to-r from-indigo-600 to-violet-600 p-2 rounded-lg shadow-md">
              <QrCode className="text-white w-5 h-5" />
            </div>
            <span className="font-bold text-xl tracking-tight text-slate-800">QuickQR<span className="text-indigo-600">Pro</span></span>
          </div>
          <div className="flex gap-3">
             <button className="hidden sm:flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-indigo-600 transition-colors px-3 py-2 rounded-md hover:bg-slate-50">
               <Share2 size={16} /> <span className="hidden md:inline">Udostępnij</span>
             </button>
             
             {/* PRZYCISK BUYCOFFEE - TWOJE ZARABIANIE */}
             <button 
               onClick={() => window.open('https://buycoffee.to/szybki-qr.pl', '_blank')}
               className="bg-amber-100 text-amber-900 px-4 py-2 rounded-full text-sm font-bold flex items-center gap-2 hover:bg-amber-200 transition-all shadow-sm hover:shadow-md transform hover:-translate-y-0.5 cursor-pointer border border-amber-200"
             >
               <Coffee size={16} className="text-amber-700" /> <span className="hidden md:inline">Postaw mi kawę</span>
             </button>
          </div>
        </div>
      </nav>

      {/* MAIN CONTENT */}
      <main className="flex-grow w-full max-w-5xl mx-auto px-4 py-8 lg:py-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
        
        {/* LEFT COLUMN - CONFIGURATION */}
        <div className="lg:col-span-7 space-y-6">
          
          {/* STEP 1 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-[0_4px_20px_-5px_rgba(0,0,0,0.1)] border border-slate-100">
            <h2 className="text-lg font-bold mb-6 flex items-center gap-2 text-slate-700">
              <div className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center text-sm">1</div>
              Wybierz rodzaj
            </h2>
            <div className="grid grid-cols-3 gap-4">
              <button onClick={() => setType('url')} className={`p-4 rounded-xl border-2 flex flex-col items-center gap-3 transition-all ${type === 'url' ? 'border-indigo-600 bg-indigo-50/50 text-indigo-700 shadow-sm' : 'border-slate-100 hover:border-indigo-200 hover:bg-slate-50'}`}>
                <LinkIcon size={24} /> <span className="font-medium text-sm">Link WWW</span>
              </button>
              <button onClick={() => setType('wifi')} className={`p-4 rounded-xl border-2 flex flex-col items-center gap-3 transition-all ${type === 'wifi' ? 'border-indigo-600 bg-indigo-50/50 text-indigo-700 shadow-sm' : 'border-slate-100 hover:border-indigo-200 hover:bg-slate-50'}`}>
                <Wifi size={24} /> <span className="font-medium text-sm">Wi-Fi</span>
              </button>
              <button onClick={() => setType('text')} className={`p-4 rounded-xl border-2 flex flex-col items-center gap-3 transition-all ${type === 'text' ? 'border-indigo-600 bg-indigo-50/50 text-indigo-700 shadow-sm' : 'border-slate-100 hover:border-indigo-200 hover:bg-slate-50'}`}>
                <Type size={24} /> <span className="font-medium text-sm">Tekst</span>
              </button>
            </div>
          </div>

          {/* STEP 2 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-[0_4px_20px_-5px_rgba(0,0,0,0.1)] border border-slate-100">
            <h2 className="text-lg font-bold mb-6 flex items-center gap-2 text-slate-700">
              <div className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center text-sm">2</div>
              Wpisz dane
            </h2>
            
            {type === 'url' && (
              <div>
                <label className="block text-sm font-medium text-slate-500 mb-2 uppercase tracking-wide text-xs">Adres strony</label>
                <input type="url" value={text} onChange={(e) => setText(e.target.value)} className="w-full p-4 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all bg-slate-50 focus:bg-white text-lg" placeholder="https://twoja-strona.pl" />
              </div>
            )}
            {type === 'text' && (
              <div>
                <label className="block text-sm font-medium text-slate-500 mb-2 uppercase tracking-wide text-xs">Twój tekst</label>
                <textarea value={text} onChange={(e) => setText(e.target.value)} className="w-full p-4 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all h-32 bg-slate-50 focus:bg-white" placeholder="Wpisz tutaj wiadomość..." />
              </div>
            )}
            {type === 'wifi' && (
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-500 mb-2 uppercase tracking-wide text-xs">Nazwa sieci (SSID)</label>
                  <input type="text" value={ssid} onChange={(e) => setSsid(e.target.value)} className="w-full p-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none bg-slate-50" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-500 mb-2 uppercase tracking-wide text-xs">Hasło</label>
                  <div className="relative">
                    <Lock className="absolute left-3 top-3.5 text-slate-400 w-5 h-5" />
                    <input type="text" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full pl-10 p-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none bg-slate-50" />
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* STEP 3 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-[0_4px_20px_-5px_rgba(0,0,0,0.1)] border border-slate-100">
             <h2 className="text-lg font-bold mb-6 flex items-center gap-2 text-slate-700">
              <div className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center text-sm">3</div>
              Kolory
            </h2>
             <div className="flex flex-wrap gap-8">
               <div>
                  <label className="block text-xs font-bold text-slate-400 uppercase mb-2">Kolor kodu</label>
                  <div className="flex items-center gap-3 bg-slate-50 p-2 rounded-lg border border-slate-100">
                    <input type="color" value={`#${color}`} onChange={(e) => setColor(e.target.value.replace('#', ''))} className="h-10 w-12 cursor-pointer rounded border-0 p-0" />
                    <span className="font-mono text-sm text-slate-600">#{color}</span>
                  </div>
               </div>
               <div>
                  <label className="block text-xs font-bold text-slate-400 uppercase mb-2">Kolor tła</label>
                  <div className="flex items-center gap-3 bg-slate-50 p-2 rounded-lg border border-slate-100">
                    <input type="color" value={`#${bgColor}`} onChange={(e) => setBgColor(e.target.value.replace('#', ''))} className="h-10 w-12 cursor-pointer rounded border-0 p-0" />
                     <span className="font-mono text-sm text-slate-600">#{bgColor}</span>
                  </div>
               </div>
             </div>
          </div>
        </div>

        {/* RIGHT COLUMN - PREVIEW */}
        <div className="lg:col-span-5 space-y-6 lg:sticky lg:top-24">
          
          {/* PREVIEW CARD */}
          <div className="bg-gradient-to-br from-indigo-600 to-violet-700 p-1 rounded-3xl shadow-xl">
            <div className="bg-white p-8 rounded-[22px] flex flex-col items-center text-center">
               <h3 className="font-bold text-slate-800 text-lg mb-6 flex items-center gap-2">
                 <Sparkles className="text-amber-500" size={20} /> Podgląd na żywo
               </h3>
               
               <div className="bg-slate-100 p-6 rounded-2xl mb-6 shadow-inner border border-slate-200">
                 <img src={qrUrl} alt="QR Code" className="w-56 h-56 object-contain mix-blend-multiply" />
               </div>
               
               <button onClick={handleDownload} className="w-full bg-slate-900 hover:bg-slate-800 text-white font-bold py-4 px-6 rounded-xl flex items-center justify-center gap-3 transition-all shadow-lg hover:shadow-xl transform active:scale-95">
                 <Download size={20} /> Pobierz PNG
               </button>
            </div>
          </div>

          {/* SEKJA REKLAMOWA (PARTNERSKA) - TUTAJ WKLEISZ SWÓJ LINK */}
          <div className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm overflow-hidden relative">
            <span className="absolute top-3 right-3 text-[10px] font-bold uppercase tracking-widest text-slate-300">Polecane</span>
            
            <a 
              href="TU_WKLEJ_TWOJ_LINK_PARTNERSKI" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group block"
            >
              <div className="flex items-center gap-4 mb-3">
                 <div className="bg-blue-100 p-3 rounded-xl text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors">
                    <Zap size={24} />
                 </div>
                 <div>
                    <h4 className="font-bold text-slate-800 leading-tight">Twój Hosting jest za wolny?</h4>
                    <p className="text-xs text-slate-500 mt-1">Sprawdź ofertę polecaną przez ekspertów.</p>
                 </div>
              </div>
              <div className="bg-slate-50 rounded-lg p-3 text-center border border-slate-100 group-hover:border-blue-200 transition-colors">
                 <span className="text-blue-600 font-bold text-sm flex items-center justify-center gap-2">
                   Odbierz rabat na start <ShieldCheck size={14} />
                 </span>
              </div>
            </a>
          </div>

        </div>
      </main>

      {/* FOOTER */}
      <footer className="bg-slate-900 text-slate-400 border-t border-slate-800">
        <div className="max-w-5xl mx-auto px-4 py-12">
           <div className="flex flex-col md:flex-row justify-between items-center gap-6">
              <div className="flex items-center gap-2">
                 <QrCode className="text-indigo-500 w-6 h-6" />
                 <span className="text-slate-200 font-bold text-lg">QuickQR Pro</span>
              </div>
              <p className="text-sm text-center md:text-right">
                &copy; 2025. Stworzone w Polsce. <br className="md:hidden"/> Wszelkie prawa zastrzeżone.
              </p>
           </div>
        </div>
      </footer>
    </div>
  );
}